/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { Component } from 'react';
import {
    object, string, func, number, bool, array,
} from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import ReactHtmlParser from 'react-html-parser';
import withStyles from '@material-ui/core/styles/withStyles';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import CreateIcon from '@material-ui/icons/Create';
import Divider from '@material-ui/core/Divider';
import { bindActionCreators } from 'redux';
import configENV from '../../../config';
import subscriptionConfig from '../../../../../helpers/common/subscription/subscription-helpers';
import SubscriptionDialog from '../Dialogs/SubscriptionDialog';
import SubscriptionRecipientFormDialog from '../SubscriptionRecipientForm/SubscriptionRecipientFormDialog';
import { clearErrors } from '../../../../../../state/ducks/Common/ducks/Error/Error-Actions';
import { clearRecipientFormFields } from '../../../../../../state/ducks/Recipient/ducks/RecipientForm/RecipientForm-Actions';
import { getCustomerEmail } from '../../../state/ducks/Common/Common-Selectors';
import SubscriptionEditGiftMsgDialog from '../SubsriptionGiftMessage/SubscriptionEditGiftMsgDialog';
import EventDispatcher from '../../../state/reducers/EventDispatcher';
import SubsriptionFrequencyModalDialog from '../SubsriptionFrequency/SubsriptionFrequencyDialog';
// import CalendarVariation from '../../../../Checkout/containers/Common/CalendarVariation/CalendarVariation';
import { getCryptedOrderDetailsURL } from '../../../utils/crypto';
import { getBaseCode } from '../../../../../helpers/tracking/product/dataLayerProductHelpers';
import { trackEvent as track } from '../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';
import AgeZipVerification from '../Dialogs/AgeZipVerification';
import { getValidatedZipcode } from '../../../../../../state/ducks/App/App-Selectors';
import pastEndDate from '../Partials/CommonUtils';
import { isEmpty } from '../../../utils/object';
import MaskInput from '../Partials/TextFieldWrapper/MaskInput';

const { PERSIST_KEY } = configENV;

const styles = () => ({
    divider: {
        margin: '23px 0 24px 0',
    },
    editButton: {
        fontSize: '12px',
        padding: '0 8px 0 12px',
        color: ' #4A90E2',
        textDecoration: 'underline',
    },
    editIcon: {
        width: '14px',
        color: ' #4A90E2',
    },
    subContainer: {
        display: 'flex',
        alignItems: 'center',
    },
    nextOrderDate: {
        fontStyle: 'italic',
    },
    shipmentInfo: {
        fontSize: '16px',
        fontWeight: '700',
        margin: '19px 0 12px 0',
        lineHeight: '24px',
    },
    trackOrder: {
        fontSize: '14px',
        fontWeight: '700',
        lineHeight: '17px',
        display: 'flex',
        alignItems: 'center',
        textDecoration: 'underline',
    },
    shippingIcon: {
        marginRight: '8px',
    },
    recipientEditContainer: {
        width: '100%',
        display: 'flex',
        justifyContent: 'flex-end',
    },
    recipientContainer: {
        margin: '20px 0',
        fontSize: '16px',
        lineHeight: '24px',
        width: '220px',
        overflowWrap: 'break-word',
    },
    recipient: {
        fontWeight: 600,
    },
    recipientEditButton: {
        margin: '20px 0',
    },
    recipientName: {
        textTransform: 'uppercase',
    },
    frequencyContainer: {
        margin: '20px 0 16px 0',
    },
});

function subscriptionDuration(d) {
    const SUBSCRIPTION_DURATIONS = subscriptionConfig?.subscription_duration;
    return SUBSCRIPTION_DURATIONS[d] ? SUBSCRIPTION_DURATIONS[d] : d;
}

function subscriptionInterval(i) {
    const SUBSCRIPTION_INTERVALS = subscriptionConfig?.subscription_interval;
    return SUBSCRIPTION_INTERVALS[i] ? SUBSCRIPTION_INTERVALS[i] : i;
}

function ShipmentHistory(shipmentHistory) {
    return (
        <div className={shipmentHistory.classes.shipmentInfo}>
            <div>Shipment Info</div>
            <div>Order #: {shipmentHistory?.history?.[0]?.orderNumber || 'N/A' }</div>
            <div>Delivery Date: {shipmentHistory?.history?.[0]?.deliveryDate || 'N/A' }</div>
        </div>
    );
}

class MobileSubscriptionDetail extends Component {
    constructor(props) {
        super(props);
        const { selectedSubscription } = this.props;
        this.state = {
            subscriptionDialogOpen: false,
            messages: {
                title: '',
                body: '',
                cancel: '',
                confirm: '',
            },
            handleConfirmDialog: () => {},
            handleCancelDialog: () => {},
            isOpen: false,
            recipientData: selectedSubscription.recipient?.[0] || {},
            giftEditMessageOpen: false,
            frequencyModalOpen: false,
            deliveryCalOpen: false,
        };
    }

    removeUSZipCodeSegment = (zipcode) => {
        if (/\d{5}-\d{4}/.test(zipcode)) {
            const zipSplit = zipcode.split('-');
            return zipSplit[0];
        }
        return zipcode;
    }

    handleOpenRecipientDialog =(isOpen) => {
        const { selectedSku, handleMobileAgeVerification, featureFlags } = this.props;

        // ageVerifyFlag coming in aggregator call is not boolean value
        if (featureFlags['is-ws-age-verification-enabled'] && selectedSku?.ageVerifyFlag === 'true') handleMobileAgeVerification(true);
        else this.setState({ isOpen });
    }

    handleRecipientSubmit =(recipientData) => {
        this.setState({ recipientData });
    }

    closeClick = (buttonClicked) => {
        const {
            callClearErrors, callClearRecipientFormFields, trackEvent,
        } = this.props;

        trackEvent({
            eventCategory: 'Subscriptions Management Portal',
            eventAction: 'click – Edit Recipient Modal',
            eventLabel: `${buttonClicked || 'Save'}`,
        });

        this.setState({ isOpen: false });
        callClearErrors({
            errType: 'recipientFormClearAllFields',
        });
        callClearRecipientFormFields();
    };

   closeFrequencyModal = () => {
       this.setState({ frequencyModalOpen: false });
   }

    handleCancelDialogClose = () => {
        this.setState({ subscriptionDialogOpen: false });
    }

    handleCancelConfirmed = () => {
        const { handleCancel } = this.props;
        this.setState({ subscriptionDialogOpen: false });
        handleCancel();
    }

    handleFrequencyModal = () => {
        this.setState({ frequencyModalOpen: true });
    }

    handleEditGiftMessage = (id) => {
        const { fetchSubscriptionGiftMessage } = this.props;
        if (id) fetchSubscriptionGiftMessage(id);
        this.setState({ giftEditMessageOpen: true });
    }

    handleEditGiftClose = (cancelledBool) => {
        if (cancelledBool) {
            const { trackEvent } = this.props;
            trackEvent({
                eventCategory: 'Subscriptions Management Portal',
                eventAction: 'click – Edit Card Message Modal',
                eventLabel: 'Cancel',
            });
        }

        this.setState({ giftEditMessageOpen: false });
    }

    renderSubscriptionInterval = (subscription) => {
        const { updatedInterval, successResponse, ruleId } = this.props;
        const selectedSubRuleIdMatch = ruleId === subscription.ruleId;

        if (updatedInterval && successResponse?.toLowerCase() === 'success' && selectedSubRuleIdMatch) {
            return subscriptionInterval(updatedInterval);
        }
        return subscriptionInterval(subscription.interval);
    }

    handleDeliveryCalendar = () => {
        const { deliveryCalOpen } = this.state;
        this.setState({ deliveryCalOpen: !deliveryCalOpen });
    }

    handleEditButtonAction = (event, subscription) => {
        const { trackEvent } = this.props;
        trackEvent({
            eventCategory: 'Subscriptions Management Portal',
            eventAction: 'click',
            eventLabel: `Edit - ${event}`,
        });
        switch (event) {
            case 'NEXT_DELIVERY_DATE':
                // this.handleDeliveryCalendar(true, subscription);
                break;

            case 'RECIPIENT':
                this.handleOpenRecipientDialog(true, subscription);
                break;

            case 'GIFT_MESSAGE':
                this.handleEditGiftMessage(subscription.ruleId);
                break;

            case 'FREQUENCY_AND_DURATION':
                this.handleFrequencyModal();
                break;

            default:
                break;
        }
    };

    renderChangeButton = (event, subscription) => (
        <div
            className={this.props.classes.subContainer}
            onClick={() => this.handleEditButtonAction(event, subscription)}
            aria-hidden="true"
        >
            <span className={this.props.classes.editButton}>Edit</span>
            <CreateIcon className={this.props.classes.editIcon} />
        </div>
    )

    handleTrackEvent = (eventActionValue) => {
        const { trackEvent, selectedSubscription } = this.props;
        trackEvent({
            eventCategory: 'subscription',
            eventAction: eventActionValue || '',
            eventLabel: getBaseCode(selectedSubscription?.productId) || '',
            eventValue: '1',
        });
    }

    generateViewDetailsURL = (orderNumber, history) => {
        const { trackEvent } = this.props;
        trackEvent({
            eventCategory: 'Subscriptions Management Portal',
            eventAction: 'click',
            eventLabel: 'Track Order',
        });
        const ordersURL = getCryptedOrderDetailsURL(orderNumber);
        history?.push(ordersURL);
        this.handleTrackEvent('order viewdetails');
    }

    // update list in redux state
    updateSubscriptionReduxList = (data = {}) => {
        if (isEmpty(data)) return;
        const { subscriptions, subscriptionRuleId, updateSubscriptionListState } = this.props;
        const subscriptionsList = [...subscriptions];
        const index = subscriptionsList.findIndex((sub) => sub.ruleId === subscriptionRuleId);
        if (index > -1) {
            const recipient = { ...data };
            recipient.street1 = data.address1;
            recipient.street2 = data.address2;
            recipient.zipcode = data.zipCode;
            recipient.firstAndLastName = `${data.firstName} ${data.lastName}`;
            subscriptionsList[index].recipient = [{ ...subscriptionsList[index].recipient[0], ...recipient }];
            updateSubscriptionListState(subscriptionsList);
        }
    }

    render() {
        const {
            subscriptionRuleId, classes, customerId, updateSubscriptionList, handleMobileAgeVerification, featureFlags, validatedZip,
            subscriptionsGiftMessage, selectedSubscription, history, enableEditButton, selectedSku, mobileAgeVerificationOpen,
        } = this.props;

        const {
            subscriptionDialogOpen,
            isOpen,
            recipientData,
            giftEditMessageOpen,
            handleCancelDialog,
            handleConfirmDialog,
            messages,
            frequencyModalOpen,
            // deliveryCalOpen,
        } = this.state;
        let giftMessage = subscriptionsGiftMessage?.replace('From:', '<br/> From:')?.replace('FROM: |||', '<br/> From:')?.replace('FROM:', '<br/> From:');
        if (subscriptionsGiftMessage.includes('-')) {
            const index = subscriptionsGiftMessage.lastIndexOf('-');
            const giftMsgStart = subscriptionsGiftMessage.substring(0, index);
            const giftMsgSignature = subscriptionsGiftMessage.match(/([^-]+$)/)[0];
            giftMessage = `${giftMsgStart} <br/> From: ${giftMsgSignature}`;
        }

        const nextOrderText = selectedSubscription.subscriptionStatus !== 'PAUSED' ? 'Next Order Date' : 'Next Scheduled Order Date';
        const PAY_AS_YOU_GO_ORDER = selectedSubscription?.subscriptionType?.toLowerCase() === 'monthonly';
        const recipientAddressLine1 = recipientData.street1 || recipientData.address1;
        const recipientAddressLine2 = recipientData.street2 || recipientData.address2;
        const recipientZipCode = recipientData.zipcode || recipientData.zipCode;
        const organizationName = recipientData?.organizationName || '';
        const telephoneNumber = recipientData.phone || recipientData.telephoneNumber || '';

        let validZip = '';
        if (featureFlags['is-ws-age-verification-enabled'] && selectedSku?.ageVerifyFlag === 'true') validZip = validatedZip;

        return (
            <>
                <Divider className={classes.divider} />
                <table cellPadding="0" cellSpacing="0" border="0" style={{ width: '100%' }}>
                    <thead>
                        {selectedSubscription.subscriptionStatus !== 'CANCELLED' && !pastEndDate(selectedSubscription) && (
                            <tr>
                                <td colSpan="2" className={classes.nextOrderDate}>{nextOrderText}: {selectedSubscription.nextOrderDate}</td>
                                {/* <td>{this.renderChangeButton('NEXT_DELIVERY_DATE', subscription)}</td> */}
                            </tr>
                        )}
                    </thead>
                    <tbody>
                        {selectedSubscription?.orderHistoryResult && selectedSubscription?.orderHistoryResult?.length > 0
                        && (
                            <>
                                <tr colSpan="2">
                                    <td>
                                        <ShipmentHistory history={selectedSubscription.orderHistoryResult} classes={classes} />
                                    </td>
                                </tr>
                                <tr colSpan="2">
                                    <div role="presentation" className={classes.trackOrder} onClick={() => this.generateViewDetailsURL(selectedSubscription?.orderHistoryResult?.[0]?.orderNumber, history)}><LocalShippingIcon className={classes.shippingIcon} /> TRACK ORDER</div>
                                </tr>
                            </>
                        )}
                        <tr>
                            <td>
                                <div className={classes.recipientContainer}>
                                    <div className={classes.recipient}>Recipient:</div>
                                    <div className={classes.recipientName}>{recipientData.firstName}{' '}{recipientData.lastName}</div>
                                    {organizationName && <div>{organizationName}</div>}
                                    <div>{recipientAddressLine1}{' '}{recipientAddressLine2 ? `, ${recipientAddressLine2}` : ''}</div>
                                    <div>{`${recipientData.city}, ${recipientData.state} ${this.removeUSZipCodeSegment(recipientZipCode)}`}</div>
                                    {telephoneNumber && <div>{MaskInput.Phone(telephoneNumber)?.maskInputVal}</div>}
                                </div>
                            </td>
                            {enableEditButton(selectedSubscription) && <td className={classes.recipientEditContainer}><div className={classes.recipientEditButton}>{this.renderChangeButton('RECIPIENT', selectedSubscription)}</div></td>}
                        </tr>
                        <tr>
                            <td>
                                <div className={classes.recipientContainer}>
                                    <div className={classes.recipient}>Gift Message:</div>
                                    <div>{subscriptionsGiftMessage ? ReactHtmlParser(giftMessage) : 'No Card Message'}</div>
                                </div>
                            </td>
                            {enableEditButton(selectedSubscription) && <td className={classes.recipientEditContainer}><div className={classes.recipientEditButton}>{this.renderChangeButton('GIFT_MESSAGE', selectedSubscription)}</div></td>}
                        </tr>
                        <tr>
                            <td>
                                <div className={classes.frequencyContainer}>
                                    <div className={classes.recipient}>Frequency &#38; Duration:</div>
                                    <div>{this.renderSubscriptionInterval(selectedSubscription)}</div>
                                    <div>{subscriptionDuration(selectedSubscription.duration)}</div>
                                </div>
                            </td>
                            {enableEditButton(selectedSubscription) && !PAY_AS_YOU_GO_ORDER && <td className={classes.recipientEditContainer}><div className={classes.recipientEditButton}>{this.renderChangeButton('FREQUENCY_AND_DURATION', selectedSubscription)}</div></td>}
                        </tr>
                    </tbody>
                </table>
                <SubscriptionDialog
                    open={subscriptionDialogOpen}
                    handleClose={handleCancelDialog}
                    handleConfirm={handleConfirmDialog}
                    messages={messages}
                />
                {isOpen && Object.keys(recipientData).length > 0 && <SubscriptionRecipientFormDialog validZip={validZip} ruleId={subscriptionRuleId} handleRecipientSubmit={this.handleRecipientSubmit} selectedSubscription={selectedSubscription} orderItemId={selectedSubscription.productId} closeClick={this.closeClick} isOpen={isOpen} recipientData={recipientData} customerId={customerId} updateSubscriptionReduxList={this.updateSubscriptionReduxList} />}
                {giftEditMessageOpen
                    && (
                        <SubscriptionEditGiftMsgDialog
                            closeClick={this.closeClick}
                            isOpen={giftEditMessageOpen}
                            recipientData={recipientData}
                            customerId={customerId}
                            giftEditMessageOpen={giftEditMessageOpen}
                            selectedSubscription={selectedSubscription}
                            subscriptionsGiftMessage={subscriptionsGiftMessage}
                            ruleId={subscriptionRuleId}
                            handleEditGiftClose={this.handleEditGiftClose}
                        />
                    )}
                {/* change frequency modal */}
                {frequencyModalOpen ? (
                    <SubsriptionFrequencyModalDialog
                        openModal={frequencyModalOpen}
                        closeModal={this.closeFrequencyModal}
                        subscription={selectedSubscription}
                        updateSubscriptionList={updateSubscriptionList}
                        enableEditButton={enableEditButton}
                    />
                ) : null}
                <AgeZipVerification
                    selectedSku={selectedSku}
                    selectedSubscription={selectedSubscription}
                    mobileAgeVerificationOpen={mobileAgeVerificationOpen}
                    handleMobileAgeVerification={handleMobileAgeVerification}
                    openRecipientModal={(toggle) => this.setState({ isOpen: toggle })}
                />
                {/* {deliveryCalOpen && subscriptionRuleId === selectedSubscription
                    && (
                        <CalendarVariation
                            openCalendar={deliveryCalOpen}
                            brandPresentationFamily={selectedSubscription.brand}
                            deliveryDate={selectedSubscription.orderDate}
                            subscription={selectedSubscription}
                            zipCode={recipientData.zipcode}
                            handleDeliveryCalendarClose={this.handleDeliveryCalendar}
                            pageProcess="checkout-food"
                        />
                    )} */}
            </>
        );
    }
}

MobileSubscriptionDetail.propTypes = {
    subscriptionRuleId: string.isRequired,
    selectedSubscription: object.isRequired,
    handleCancel: func.isRequired,
    classes: object.isRequired,
    callClearErrors: func.isRequired,
    callClearRecipientFormFields: func.isRequired,
    customerId: string.isRequired,
    fetchSubscriptionGiftMessage: func.isRequired,
    updateSubscriptionList: func.isRequired,
    successResponse: string.isRequired,
    updatedInterval: number.isRequired,
    ruleId: string.isRequired,
    subscriptionsGiftMessage: string,
    history: object,
    trackEvent: func.isRequired,
    enableEditButton: func.isRequired,
    selectedSku: object.isRequired,
    handleMobileAgeVerification: func.isRequired,
    mobileAgeVerificationOpen: bool.isRequired,
    featureFlags: object.isRequired,
    validatedZip: string.isRequired,
    subscriptions: array,
    updateSubscriptionListState: func.isRequired,
};

MobileSubscriptionDetail.defaultProps = {
    subscriptionsGiftMessage: '',
    history: {},
    subscriptions: [],
};

const mapStateToProps = (state) => {
    const newState = state[PERSIST_KEY] ? state[PERSIST_KEY] : state;
    return {
        validatedZip: getValidatedZipcode(state),
        subscriptions: newState.subscriptions,
        subscriptionsGiftMessage: newState.subscriptionsGiftMessage,
        customerId: getCustomerEmail(state),
        updatedInterval: newState.frequency,
        successResponse: newState.response,
        ruleId: newState.ruleId,
    };
};

const mapDispatchToProps = (dispatch) => ({
    trackEvent: bindActionCreators(track, dispatch),
    callClearErrors: bindActionCreators(clearErrors, dispatch),
    callClearRecipientFormFields: bindActionCreators(clearRecipientFormFields, dispatch),
    clearSubscriptionGiftMessage: () => dispatch(EventDispatcher.clearSubscriptionGiftMessage()),
    fetchSubscriptionGiftMessage: (ruleId) => dispatch(EventDispatcher.fetchSubscriptionGiftMessage(ruleId)),
    updateSubscriptionListState: (payload) => dispatch(EventDispatcher.updateSubscriptionList(payload)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(withStyles(styles, { withTheme: true })(MobileSubscriptionDetail)));
